import { CartLinesUpdateEvent } from '@shopify/events';

/**
 * One-click add for the cart upsell. Mirrors how the theme updates the cart (CartLinesUpdateEvent with a
 * deferred promise) so the cart drawer refreshes itself from the Section Rendering API response.
 */
document.addEventListener('click', async (event) => {
  const target = event.target;
  const button = target instanceof Element ? target.closest('[data-lt-upsell-add]') : null;
  if (!(button instanceof HTMLButtonElement) || button.disabled) return;

  const variantId = Number(button.dataset.variantId);
  const addUrl = button.dataset.addUrl;
  if (!variantId || !addUrl) return;

  const sectionId = 'cart-drawer-section';
  const deferred = CartLinesUpdateEvent.createPromise();
  button.disabled = true;

  try {
    button.dispatchEvent(
      new CartLinesUpdateEvent({
        action: 'add',
        context: 'cart',
        lines: [{ id: String(variantId), quantity: 1 }],
        promise: deferred.promise,
      })
    );

    const response = await fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }],
        sections: sectionId,
        sections_url: window.location.pathname,
      }),
    });
    const added = await response.json();
    if (!response.ok || added.status) throw new Error(added.description || added.message || 'Could not add to cart');

    const cartUrl = window.Theme?.routes?.cart_url ? `${window.Theme.routes.cart_url}.json` : '/cart.js';
    const cartResponse = await fetch(cartUrl, { headers: { Accept: 'application/json' } });
    const cart = await cartResponse.json();

    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: {
        sections: added.sections,
        items: cart.items,
        itemCount: cart.item_count,
        source: 'lt-upsell',
        didError: false,
      },
    });
  } catch (error) {
    deferred.reject(error);
    button.disabled = false;
    console.warn('[lt-upsell]', error);
  }
});
